export { default as Img200 } from './processed/200/Chernobyl-S1.jpg';
export { default as Img400 } from './processed/400/Chernobyl-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Chernobyl-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Chernobyl-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Chernobyl-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Muted": {
    "_rgb": [
      116,
      148,
      132
    ],
    "_population": 2583,
    "_hsl": [
      0.4166666666666667,
      0.1300813008130082,
      0.5176470588235295
    ]
  },
  "LightMuted": {
    "_rgb": [
      176,
      189,
      178
    ],
    "_population": 1946,
    "_hsl": [
      0.35897435897435886,
      0.08965517241379319,
      0.7156862745098039
    ]
  },
  "DarkMuted": {
    "_rgb": [
      48,
      70,
      75
    ],
    "_population": 412,
    "_hsl": [
      0.5308641975308642,
      0.21951219512195125,
      0.2411764705882353
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Chernobyl-S1.js